// import { useState, useEffect } from "react";
// import axios from "axios";
// import instance from "../../lib/axios";
// import CurrencyDropdown from "./CurrencyDropdown";

// // Debounce function
// const debounce = (func, delay) => {
//   let timer;
//   return function (...args) {
//     clearTimeout(timer);
//     timer = setTimeout(() => func.apply(this, args), delay);
//   };
// };

// const CurrencyTab = () => {
//   const [currencies, setCurrencies] = useState([]);
//   const [selectedToCurrency, setSelectedToCurrency] = useState(null);
//   const [fromAmount, setFromAmount] = useState(1);
//   const [toAmount, setToAmount] = useState("");
//   const [exchangeDetails, setExchangeDetails] = useState({
//     liveRate: "",
//     promotionOfferType: "",
//     promotionOfferValue: "",
//     deliveryTime: 0,
//     promotionAmount: "",
//     finalAmount: "",
//   });
//   const [isConverting, setIsConverting] = useState(false);
//   const [lastChangedField, setLastChangedField] = useState("from"); // 'from' or 'to'

//   // Fetch all currencies when component mounts
//   useEffect(() => {
//     fetchAllCurrencies();
//   }, []);

//   // Set default currency after fetching
//   useEffect(() => {
//     if (currencies.length > 0 && !selectedToCurrency) {
//       const defaultToCurrency = currencies.find((c) => c.currency === "USD");
//       setSelectedToCurrency(defaultToCurrency);
//     }
//   }, [currencies]);

//   // Convert when currency or amount changes
//   useEffect(() => {
//     if (selectedToCurrency && !isConverting) {
//       // Only convert if both amounts are valid numbers or one of them is empty based on lastChangedField
//       if (
//         (lastChangedField === "from" && fromAmount !== "") ||
//         (lastChangedField === "to" && toAmount !== "")
//       ) {
//         debouncedConvertCurrency();
//       }
//     }
//   }, [selectedToCurrency, fromAmount, toAmount, lastChangedField]);

//   // Fetch all currencies
//   const fetchAllCurrencies = async () => {
//     try {
//       const response = await instance.get("/api/currencies/");
//       setCurrencies(response.data.currencies);
//     } catch (err) {
//       console.error("Error fetching currencies:", err);
//     }
//   };

//   // Convert currency
//   const convertCurrency = async () => {
//     if (!selectedToCurrency) return;
    
//     // Don't convert if the active field is empty
//     if ((lastChangedField === "from" && fromAmount === "") || 
//         (lastChangedField === "to" && toAmount === "")) {
//       return;
//     }

//     setIsConverting(true);
//     try {
//       const payload = {
//         from_currency: "INR",
//         to_currency: selectedToCurrency.currency,
//         is_from_inr: lastChangedField === "to",
//         amount: lastChangedField === "to" ? toAmount : fromAmount,
//         conversion_type: "Currency",
//       };

//       const response = await instance.post("/api/convert/", payload);

//       if (response.data.status === "success") {
//         const { data } = response.data;
//         setExchangeDetails({
//           liveRate: data.live_rate,
//           promotionOfferType: data.promotion_offer_type,
//           promotionOfferValue: data.promotion_offer_value,
//           deliveryTime: data.delivery_time,
//           promotionAmount: data.promotion_amount,
//           finalAmount: data.final_amount,
//         });

//         // Update the opposite field based on the response
//         if (lastChangedField === "from") {
//           setToAmount(Number(data.final_amount));
//         } else {
//           setFromAmount(Number(parseFloat(data.final_amount)));
//         }
//       }
//     } catch (err) {
//       console.error("Error converting currency:", err);
//     } finally {
//       setIsConverting(false);
//     }
//   };

//   // Debounced version of convertCurrency
//   const debouncedConvertCurrency = debounce(convertCurrency, 100);

//   // Handle from amount change
//   const handleFromAmountChange = (e) => {
//     const value = e.target.value;
//     setFromAmount(value === "" ? "" : Number(value));
//     setLastChangedField("from");
    
//     // If value is empty, also clear the other field
//     if (value === "") {
//       setToAmount("");
//     }
//   };

//   // Handle to amount change
//   const handleToAmountChange = (e) => {
//     const value = e.target.value;
//     setToAmount(value === "" ? "" : Number(value));
//     setLastChangedField("to");
    
//     // If value is empty, also clear the other field
//     if (value === "") {
//       setFromAmount("");
//     }
//   };

//   // Handle to currency dropdown change
//   const handleToCurrencyChange = (e) => {
//     const selectedCurrency = currencies.find(
//       (c) => c.currency === e.target.value
//     );
//     setSelectedToCurrency(selectedCurrency);
//   };

//   return (
//     <>
//       <div>
//         <div className="my-[1.66rem] py-[1.0625rem] px-4 bg-white shadow-[0px_-1px_16px_0px_rgba(0,0,0,0.08)] rounded-[1.25rem]">
//           <h2 className="text-[0.66625rem] md:text-[0.75rem] text-left font-normal mb-[1.03rem]">
//             Your Currency
//           </h2>
//           <div className="flex items-center justify-between pb-[1.44rem] border-b border-[#E7E7EE]">
//             <div className="w-1/2 flex items-center p-2 ml-2  gap-2">
//               <img
//                 src="/assets/IndiaCurrrency.png"
//                 alt="Indian Currency"
//                 className="h-5 w-5 md:w-8 md:h-8"
//               />
//               <div className="text-[#1E1E1E] text-[0.75rem] md:text-[1.125rem] font-bold">
//                 INR
//               </div>
//             </div>
//             <div className="w-1/2 flex items-center text-[#0B0B0B] text-base font-bold">
//               <input
//                 type="number"
//                 className="w-full text-[0.75rem] md:text-base border border-[#E7E7EE] p-[0.75rem] rounded outline-none appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
//                 value={toAmount}
//                 onChange={handleToAmountChange}
//                 // placeholder="Enter amount"
//               />
//             </div>
//           </div>
//           <h2 className="text-[0.66625rem] md:text-[0.75rem] text-left font-normal mb-[1.03rem] mt-6">
//             Exchange Currency
//           </h2>
//           <div className="flex items-center justify-between pb-[1.44rem]">
//             <div className="w-1/2 flex items-center ">
//               {selectedToCurrency && (
//                 <CurrencyDropdown
//                   currencies={currencies}
//                   selectedToCurrency={selectedToCurrency}
//                   handleToCurrencyChange={handleToCurrencyChange}
//                 />
//               )}
//             </div>
//             <div className="w-1/2 flex items-center text-[#0B0B0B] text-base font-bold">
//               <input
//                 type="number"
//                 className="w-full text-[0.75rem] md:text-base border border-[#E7E7EE] p-[0.75rem] rounded outline-none appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
//                 value={fromAmount}
//                 onChange={handleFromAmountChange}
//                 // placeholder="Enter amount"
//               />
//             </div>
//           </div>
//         </div>

//         <h2 className="my-[1.06rem] text-[#263238] text-[0.6875rem] font-medium">
//           Transfer Time - <span className="font-bold">Within a Day</span>
//         </h2>

//         <div className="flex justify-between items-center border border-[#C2E3C3] rounded-[0.625rem] p-[0.6rem] mb-[1.06rem]">
//           <div>
//             <div className="flex items-center gap-2">
//               <img
//                 src="/assets/PromotionalExchangeRates.png"
//                 alt="PromotionalExchangeRatesIcon"
//               />
//               <div className="text-[#4F5E65] text-[0.66625rem] md:text-[0.75rem] font-medium mb-[0.62rem]">
//                 Promotional Exchange Rates
//               </div>
//             </div>
//             <div className="flex gap-[0.81rem]">
//               <div className="text-[#32434B] text-[1.08813rem] md:text-[1.429rem] font-bold">
//                 $ 1 =
//               </div>
//               <div className="text-[#32434B] text-[1.08813rem] md:text-[1.429rem] font-bold">
//                 <strike>{exchangeDetails.finalAmount}</strike>
//               </div>
//               <div className="text-[#DF2D3C] text-[1.08813rem] md:text-[1.429rem] font-bold">
//                 ₹ {exchangeDetails.liveRate}
//               </div>
//             </div>
//           </div>
//           <div className="rounded-md border border-[#C5E2C599] bg-gradient-to-b from-[#E6F6E6] to-[#E8FFE8] flex w-19 p-2.5 justify-center items-center gap-2.5">
//             <div className="text-[#4F5E65] font-medium text-[0.47588rem] md:text-[0.75rem]">
//               Save <br />
//               <span className="text-[#4BA43E] font-bold text-[0.61869rem] md:text-[0.8125rem]">
//                 ₹5,796.18{" "}
//               </span>
//               <br />
//               <span className="text-[0.47588rem] md:text-[0.625rem] font-medium">
//                 with us
//               </span>
//             </div>
//           </div>
//         </div>

//         <button className="bg-[#DF2D3C] w-full rounded-[0.23794rem] md:rounded-[0.3125rem] text-white font-bold text-[0.66625rem] md:text-[0.875rem] py-[0.57rem] md:py-3 mb-[1.06rem]">
//           Get Started
//         </button>
//         <h2 className="text-[#263238] text-[0.57106rem] md:text-[0.71875rem] font-bold">
//           Zero Fees Guaranteed !
//         </h2>
//       </div>
//     </>
//   );
// };

// export default CurrencyTab;


import { useState, useEffect } from "react";
import instance from "../../lib/axios";
import CurrencyDropdown from "./CurrencyDropdown";

// Debounce function
const debounce = (func, delay) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => func.apply(this, args), delay);
  };
};

const CurrencyTab = () => {
  const [currencies, setCurrencies] = useState([]);
  const [selectedToCurrency, setSelectedToCurrency] = useState(null);
  const [fromAmount, setFromAmount] = useState("1"); // Start with "1" as a string
  const [toAmount, setToAmount] = useState(""); // Empty string
  const [exchangeDetails, setExchangeDetails] = useState({
    liveRate: "",
    promotionOfferType: "",
    promotionOfferValue: "",
    deliveryTime: 0,
    promotionAmount: "",
    finalAmount: "",
  });
  const [isConverting, setIsConverting] = useState(false);
  const [lastChangedField, setLastChangedField] = useState("from");
  
  // Fetch all currencies when component mounts
  useEffect(() => {
    fetchAllCurrencies();
  }, []);

  // Set default currency after fetching
  useEffect(() => {
    if (currencies.length > 0 && !selectedToCurrency) {
      const defaultToCurrency = currencies.find((c) => c.currency === "USD");
      setSelectedToCurrency(defaultToCurrency);
    }
  }, [currencies]);

  // Convert when currency or amount changes
  useEffect(() => {
    if (selectedToCurrency && !isConverting) {
      // Only convert if the active field has a value
      if ((lastChangedField === "from" && fromAmount !== "") || 
          (lastChangedField === "to" && toAmount !== "")) {
        debouncedConvertCurrency();
      }
    }
  }, [selectedToCurrency, fromAmount, toAmount, lastChangedField]);

  // Fetch all currencies
  const fetchAllCurrencies = async () => {
    try {
      const response = await instance.get("/api/currencies/");
      setCurrencies(response.data.currencies);
    } catch (err) {
      console.error("Error fetching currencies:", err);
    }
  };

  // Convert currency
  const convertCurrency = async () => {
    if (!selectedToCurrency) return;
    
    // Don't convert if the active field is empty
    if ((lastChangedField === "from" && fromAmount === "") || 
        (lastChangedField === "to" && toAmount === "")) {
      return;
    }

    setIsConverting(true);
    try {
      const payload = {
        from_currency: "INR",
        to_currency: selectedToCurrency.currency,
        is_from_inr: lastChangedField === "to",
        amount: lastChangedField === "from" ? fromAmount : toAmount,
        conversion_type: "Currency",
      };

      const response = await instance.post("/api/convert/", payload);

      if (response.data.status === "success") {
        const { data } = response.data;
        setExchangeDetails({
          liveRate: data.live_rate,
          promotionOfferType: data.promotion_offer_type,
          promotionOfferValue: data.promotion_offer_value,
          deliveryTime: data.delivery_time,
          promotionAmount: data.promotion_amount,
          finalAmount: data.final_amount,
        });

        // Only update the opposite field if the current field has a value
        if (lastChangedField === "from" && fromAmount !== "") {
          setToAmount(String(data.final_amount));
        } else if (lastChangedField === "to" && toAmount !== "") {
          setFromAmount(String(data.final_amount));
        }
      }
    } catch (err) {
      console.error("Error converting currency:", err);
    } finally {
      setIsConverting(false);
    }
  };

  // Debounced version of convertCurrency
  const debouncedConvertCurrency = debounce(convertCurrency, 300);

  // Handle from amount change
  const handleFromAmountChange = (e) => {
    const value = e.target.value;
    setFromAmount(value);
    setLastChangedField("from");
    
    // If value is empty, also clear the other field
    if (value === "") {
      setToAmount("");
    }
  };

  // Handle to amount change
  const handleToAmountChange = (e) => {
    const value = e.target.value;
    setToAmount(value);
    setLastChangedField("to");
    
    // If value is empty, also clear the other field
    if (value === "") {
      setFromAmount("");
    }
  };

  // Handle to currency dropdown change
  const handleToCurrencyChange = (e) => {
    const selectedCurrency = currencies.find(
      (c) => c.currency === e.target.value
    );
    setSelectedToCurrency(selectedCurrency);
  };

  return (
    <>
      <div>
        <div className="relative">
          <div className="absolute top-0 left-[1.9rem] h-full w-[2px] bg-[#FCEBEE] z-0"></div>
          <div className="relative z-50">
            {/* You Want Section */}
            <div className="flex justify-between bg-white shadow-[0px_4px_0px_0px_rgba(0,0,0,0.07)] py-[0.625rem] px-4 border border-[#FFDEE4] rounded-[0.25rem] my-6">
              <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
              <div className="w-1/2">
                <div className="relative z-10 text-[#505050] text-[1rem] text-left font-normal">
                  You Want
                </div>
                <div className="relative z-10 flex items-center text-[#0B0B0B] text-base font-bold">
                  <input
                    type="number"
                    className="w-full text-[0.75rem] md:text-base border-none outline-none appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                    value={fromAmount}
                    onChange={handleFromAmountChange}
                  />
                </div>
              </div>
              <div className="relative z-10 w-1/2 flex items-center justify-end">
                {selectedToCurrency && (
                  <CurrencyDropdown
                    currencies={currencies}
                    selectedToCurrency={selectedToCurrency}
                    handleToCurrencyChange={handleToCurrencyChange}
                  />
                )}
              </div>
            </div>

            <div className="border relative z-8 flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border-[#FFDEE4] rounded-[0.25rem]">
              <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
              <div className="relative z-10 text-[#3C3C3C] text-[0.875rem] font-bold">
                {exchangeDetails.liveRate} INR
              </div>
              <div className="relative  flex items-center gap-2">
                <div>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="7"
                    height="7"
                    viewBox="0 0 7 7"
                    fill="none"
                  >
                    <circle cx="3.5" cy="3.5" r="3.5" fill="#40C541" />
                  </svg>
                </div>
                <div className="text-[#EC5875] text-[0.875rem] font-medium">
                  Live Fx Rate
                </div>
              </div>
            </div>

            <div className="relative  flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] mt-3 mb-1">
              <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
              <div className="relative z-10 text-[#3C3C3C] text-[0.875rem] font-bold">
                0 INR
              </div>
              <div className="relative  text-[#EC5875] text-[0.875rem] font-medium">
                Platform Fees
              </div>
            </div>

            <div className="relative  flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] mt-3">
              <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
              <div className="relative z-10 text-[#3C3C3C] text-[0.875rem] font-bold">
                {exchangeDetails.promotionAmount} INR
              </div>
              <span className="absolute top-[-21%] left-[6%] z-20">
                <img src="/assets/MinusIcon.png" alt="MinusIcon" />
              </span>
              <div className="relative  text-[#EC5875] text-[0.875rem] font-medium">
                Promotion
              </div>
            </div>
            <div className="relative  border-b-2 border-dashed border-[#FCEBEE] p-2" />

            <div className="relative flex justify-between py-[0.4375rem] px-[0.8125rem] bg-white border border-[#FFDEE4] rounded-[0.25rem] mt-4">
              <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
              <div className="relative z-10 text-[#3C3C3C] text-[0.875rem] font-bold">
                Instant
              </div>
              <span className="absolute top-[-21%] left-[6%] z-20">
                <img src="/assets/LeftArrowIcon.png" alt="LeftArrowIcon" />
              </span>
              <div className="relative  text-[#EC5875] text-[0.875rem] font-medium">
                Delivery
              </div>
            </div>

            <div className="relative  flex justify-between py-[0.4375rem] px-[0.8125rem] bg-[rgba(255,248,249,0.44)] border border-[#FFDEE4] rounded-[0.25rem] mt-3">
              <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
              <div className="relative  text-[#3C3C3C] text-[0.875rem] font-bold">
                Online
              </div>
              <span className="absolute top-[-21%] left-[6%] z-20">
                <img src="/assets/EqualIcon.png" alt="EqualIcon" />
              </span>
              <div className="relative  text-[#EC5875] text-[0.875rem] font-medium">
                Payment Mode
              </div>
            </div>

            {/* You Have Section (Always INR) */}
            <div className="relative z-10 flex justify-between bg-white shadow-[0px_4px_0px_0px_rgba(0,0,0,0.07)] py-[0.625rem] px-4 border border-[#FFDEE4] rounded-[0.25rem] my-6">
              <div className="absolute inset-0 bg-[rgba(255,248,249,0.44)] rounded-[0.25rem]"></div>
              <div className="w-1/2">
                <div className="relative z-10 text-[#505050] text-[0.875rem] font-normal text-left">
                  You have
                </div>
                <div className="relative z-10 flex items-center text-[#3C3C3C] text-[0.75rem] md:text-base font-bold">
                  <input
                    type="number"
                    className="w-full text-[0.75rem] md:text-base border-none outline-none appearance-none [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                    value={toAmount}
                    onChange={handleToAmountChange}
                  />
                </div>
              </div>
              <div className="relative z-10 w-1/2 flex items-center justify-end gap-2">
                <img
                  src="/assets/IndiaCurrrency.png"
                  alt="Indian Currency"
                  className="w-5 h-5 md:w-8 md:h-8"
                />
                <div className="text-[#1E1E1E] text-[0.75rem] md:text-[1.125rem] font-bold">
                  INR
                </div>
              </div>
            </div>
          </div>
        </div>

        <button className="bg-[#DF2D3C] w-[70%] rounded-[0.23794rem] md:rounded-[0.3125rem] text-white font-bold text-[0.66625rem] md:text-[1rem] py-[0.57rem] md:py-3 mb-[1.06rem]">
          Get Started
        </button>
        <div className="flex justify-between md:justify-around items-center">
          <div className="">
            <h2 className="text-[#1D1D1D] text-center text-[0.625rem] font-normal">
              You could save upto{" "}
              <span className="text-[#DC143C] text-[0.875rem] font-bold">
                ₹{exchangeDetails.finalAmount}
              </span>
            </h2>
          </div>
          <div className="h-6 w-[1px] bg-[#CDCDCD]"></div>

          <div className="flex justify-around items-center p-[0.625rem] gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="11"
              height="14"
              viewBox="0 0 11 14"
              fill="none"
            >
              <path
                d="M2.83398 5.66667V3.66667C2.83398 2.95942 3.11494 2.28115 3.61503 1.78105C4.11513 1.28095 4.79341 1 5.50065 1C6.2079 1 6.88617 1.28095 7.38627 1.78105C7.88637 2.28115 8.16732 2.95942 8.16732 3.66667V5.66667"
                stroke="black"
                strokeLinecap="round"
              />
              <path
                d="M0.833984 5.66699H10.1673V11.667C10.1673 12.0206 10.0268 12.3598 9.77679 12.6098C9.52674 12.8598 9.18761 13.0003 8.83398 13.0003H2.16732C1.8137 13.0003 1.47456 12.8598 1.22451 12.6098C0.97446 12.3598 0.833984 12.0206 0.833984 11.667V5.66699Z"
                stroke="black"
                strokeLinejoin="round"
              />
              <path
                d="M7.16797 9.33301H7.17464V9.33967H7.16797V9.33301Z"
                stroke="black"
                strokeWidth="2.25"
                strokeLinejoin="round"
              />
            </svg>
            <h2 className="text-[#1D1D1D] text-center text-[0.625rem] font-bold">
              24hr Rate Freeze <span className="font-normal">- at No Cost</span>
            </h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default CurrencyTab;
